import { AxiosRequestHeaders } from 'axios';
import { DtoTypes, RpcClientFactory } from '..';
import { capability } from '../rpc-client/config/capabilities';

export async function createCallMeActivityForPolicy(
    policyNumber: string,
    phoneNumber: string,
    headers: AxiosRequestHeaders = {}
): Promise<DtoTypes.PC.top.edge.capabilities.activity.dto.ActivityResultDTO> {
    return await RpcClientFactory.getInstance().rpcCall<DtoTypes.PC.top.edge.capabilities.activity.dto.ActivityResultDTO>(
        capability.PC_ACTIVITY,
        'createPolicyCallMeActivityTop',
        [policyNumber, phoneNumber],
        headers
    );
}
